import React, { useState } from 'react';

const ForecastTable = ({ forecastData, handleGetCityName }) => {

    const [selectedCity, setSelectedCity] = useState("");

    // Get unique cities from the data
    const cities = forecastData && Array.isArray(forecastData)
        ? [...new Set(forecastData.map((entry) => entry.city))]
        : [];

    // Filter data based on selected city
    const filteredData = selectedCity
        ? forecastData.filter((entry) => entry.city === selectedCity)
        : [];

    return (
        <>
            <h2
                style={{ margin: "5vh 0 5vh 0" }}
                className="text-3xl font-bold mb-4 text-center"
            >
                Forecast Table
            </h2>
            <div style={{ marginTop: "5vh 0 5vh 0" }} className="mycontainer manage-workflow-box">
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="w-full">
                                {/* City Selection Dropdown */}
                                <div className="my-4">
                                    <label
                                        htmlFor="city-select"
                                        className="mr-2 text-lg font-semibold text-gray-700"
                                    >
                                        Select City:
                                    </label>
                                    <select
                                        id="city-select"
                                        className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0C3C54]"
                                        value={selectedCity}
                                        onChange={(e) => {
                                            setSelectedCity(e.target.value)
                                            handleGetCityName(e.target.value)
                                        }
                                        }
                                    >
                                        <option value="">-- Select City --</option>
                                        {cities.map((city, index) => (
                                            <option key={index} value={city}>
                                                {city}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Forecast Table */}
                                <div className="overflow-x-auto">
                                    <table className="table dataselectiontable table-bordered">
                                        <thead>
                                            <tr className="bg-blue-900 text-white">
                                                <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">
                                                    SKU
                                                </th>
                                                {[...new Set(
                                                    filteredData.flatMap((entry) =>
                                                        entry.data.flatMap((skuEntry) =>
                                                            skuEntry.data.map(
                                                                (forecastEntry) => forecastEntry.frequency_year
                                                            )
                                                        )
                                                    )
                                                )]
                                                    .sort()
                                                    .map((frequencyYear, index) => (
                                                        <th
                                                            key={index}
                                                            className="border border-gray-300 p-2 bg-[#0C3C54] text-white"
                                                        >
                                                            {frequencyYear}
                                                        </th>
                                                    ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData && filteredData.length > 0 ? (
                                                filteredData.flatMap((entry) =>
                                                    entry.data.map((skuEntry) => {
                                                        // Create a mapping of frequency_year to forecast for each SKU
                                                        const forecastMap = {};
                                                        skuEntry.data.forEach((forecastEntry) => {
                                                            forecastMap[
                                                                forecastEntry.frequency_year
                                                            ] = forecastEntry.forecast;
                                                        });

                                                        return (
                                                            <tr
                                                                key={skuEntry.sku}
                                                                className="hover:bg-gray-100"
                                                            >
                                                                <td className="border border-gray-300 p-2">
                                                                    {skuEntry.sku}
                                                                </td>
                                                                {[...new Set(
                                                                    filteredData.flatMap((entry) =>
                                                                        entry.data.flatMap((skuEntry) =>
                                                                            skuEntry.data.map(
                                                                                (forecastEntry) =>
                                                                                    forecastEntry.frequency_year
                                                                            )
                                                                        )
                                                                    )
                                                                )]
                                                                    .sort()
                                                                    .map((frequencyYear, index) => (
                                                                        <td
                                                                            key={index}
                                                                            className="border border-gray-300 p-2"
                                                                        >
                                                                            {forecastMap[frequencyYear] || "-"}
                                                                        </td>
                                                                    ))}
                                                            </tr>
                                                        );
                                                    })
                                                )
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center p-4">
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    );
};

export default ForecastTable;
